module.exports = __webpack_public_path__ + "static/media/notes.254143a5.PNG";